import { Route } from '@angular/router';
import {
  assetInformationRoutes
} from '@app/features/analysis-refactor/pages/analysis-configuration/pages/asset-information1/asset-information.route';
import {
  marketAnalysisRoute
} from '@app/features/analysis-refactor/pages/analysis-configuration/pages/market-analysis/market-analysis.route';
import {
  financialAnalysisRoute
} from '@app/features/analysis-refactor/pages/analysis-configuration/pages/financial-analysis/financial-analysis.route';
import {HbuRoute} from '@app/features/analysis-refactor/pages/analysis-configuration/pages/hbu/hbu.route';
import {
  RegulatoryAnalysisRoutes
} from '@app/features/analysis-refactor/pages/analysis-configuration/pages/regulatory-analysis/regulatory-analysis.route';

export const analysisRefactorConfigRoutes: Route[] = [
  {
    path: ':region/:landId',
    loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/analysis-configuration.component')
      .then(m => m.AnalysisConfigurationComponent),
      children: [
        {
          path: 'executive-summary',
          loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/executive-summary/executive-summary.component')
        },
        {
          path: 'asset-information',
          children: [
            ...assetInformationRoutes
          ]
        },
        // ============ Market Analysis Section ============
        {
          path: 'market-analysis',
          children: [
            ...marketAnalysisRoute

          ]
        },

        // ============ HBU Section ============

        {
          path: 'hbu',
          children: [
            ...HbuRoute
          ]
        },
        // ============ Financial Analysis Section ============
        {
          path: 'financial-analysis',
          children: [
            ...financialAnalysisRoute
          ]
        },

        // ============ Other Sections ============
        {
          path: 'business-model',
          loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/business-model/business-model.component')
        },

        {
          path: 'regulatory-analysis',
          children: [
            ...RegulatoryAnalysisRoutes
          ]
        },
        {
          path: 'risk-register',
          loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/risk-register/risk-register.component'),
        },
        {
          path: 'land-valuation',
          loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/land-valuation/land-valuation.component'),
        }
      ]
  }
];
